import { saveSettings, type VisualSettings } from '../../engine/Settings.js';
import type { SettingsSection } from '../SettingsModal.js';
import { addNote, addToggle } from './formHelpers.js';

/** Debug section: just the "Show debug overlay" toggle. The render diagnostics
 *  (shadows, post-fx, sky, terrain, vehicle fx, camera mods) live in the Visual
 *  section since they are user-facing rendering features, not developer-only
 *  bisection switches. */
export function createDebugSection(
  settings: VisualSettings,
  onChange: (changed: Set<keyof VisualSettings>) => void,
): SettingsSection {
  return {
    id: 'debug',
    title: 'Debug',
    build(parent: HTMLElement): void {
      parent.replaceChildren();
      addToggle(parent, 'Show debug overlay', settings.showDebugOverlay, (checked) => {
        settings.showDebugOverlay = checked;
        saveSettings(settings);
        onChange(new Set<keyof VisualSettings>(['showDebugOverlay']));
      });
      addNote(parent, 'FPS, GPU ms, draws, triangles, LOD pill — shown bottom-left when on.');
    },
  };
}
